import { createSelector } from "@reduxjs/toolkit";

export const evidenceState = (state) => state.evidence;

export const evidenceSelectors = createSelector(evidenceState, (state) => state);
